import React, { useState } from 'react';
import { useIntl } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss, Flex, Box, Stack } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import { IconButton } from '@atlaskit/button/new';

import { messages } from '../../messages';

type LoomScriptExpandProps = {
	title: string;
	children: React.ReactNode;
};

const containerStyles = xcss({
	border: `1px solid ${token('color.border')}`,
	borderRadius: 'border.radius.100',
	padding: 'space.100',
	backgroundColor: 'color.background.neutral.subtle',
	marginTop: 'space.100',
	marginBottom: 'space.100',
});

const headerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	gap: 'space.050',
});

const headerTextStyles = xcss({
	color: 'color.text.subtlest',
	font: token('font.body.small'),
});

const contentStyles = xcss({
	margin: 'space.050',
	paddingBlock: 'space.100',
	paddingInline: 'space.300',
	whiteSpace: 'pre-wrap',
	color: 'color.text.subtlest',
	font: token('font.body.small'),
});

export const LoomScriptExpand = ({ title, children }: LoomScriptExpandProps) => {
	const [expanded, setExpanded] = useState(false);
	const { formatMessage } = useIntl();
	return (
		<Stack xcss={containerStyles} aria-labelledby="loom-script-expand-section">
			<Flex xcss={headerStyles} wrap="nowrap">
				<IconButton
					onClick={() => setExpanded(!expanded)}
					icon={expanded ? ChevronDownIcon : ChevronRightIcon}
					aria-expanded={expanded}
					appearance="subtle"
					spacing="compact"
					testId="loom-script-expand-toggle"
					label={
						expanded
							? formatMessage(messages.loomScriptCollapseSectionLabel)
							: formatMessage(messages.loomScriptExpandSectionLabel)
					}
				/>
				<Box xcss={headerTextStyles} id="loom-script-expand-header">
					{title}
				</Box>
			</Flex>
			{expanded && (
				<Box xcss={contentStyles} testId="loom-script-expand-content">
					{children}
				</Box>
			)}
		</Stack>
	);
};
